import ServiceBus from 'servicestack/service-bus'
import AutoQuery from 'servicestack/auto-query/auto-query'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import modals from 'webmodals/modals'

class MediaFieldsetController {
    constructor() {
        basicController(this)
    }

    $onInit() {
        this.message = 'Loading Tags';
        ServiceBus.read('QueryMediaTagKinds.json').then(res => {
            res.data.results.forEach(r => this.addTagKind(r.tagKind));
            this.message = false;
        });
    }

    addTagKindPrompt() {
        modals.prompt('Add Tag Kind...')
            .result
            .then(tk => this.addTagKind(tk));
    }

    addTagKind(tk) {
        if (!this.request)
            this.request = {};
        if (!this.request.tags)
            this.request.tags = {};
        if (!this.request.tags[tk])
            this.request.tags[tk] = [];
    }

    upload($files) {
        let $ctrl = this;
        if (($files && $files.length) || ($ctrl.request.urls && $ctrl.request.urls.length)) {
            $ctrl.$files = $files;
            $ctrl.uploading = {};
            let req = {
                request: $ctrl.request,
                files: $files
            };

            $ctrl.bus.upload('CreateMedia.json', req).then(
                res => {
                    $ctrl.request.urls = [];
                    $ctrl.close(res.data);
                }, res => modals.alert(JSON.stringify(res), 'Could not save media!'));
        }
    }

    submit() {
        const $ctrl = this;
    }
}

export default MediaFieldsetController;